import { useLocation, useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";
import {
  TbEye,
  TbFocus2,
  TbCalendar,
  TbHeart,
  TbSettings,
  TbPigMoney,
} from "react-icons/tb";
import PropTypes from "prop-types";
import NativeSettings from "../../plugins/NativeSettings";

export default function NativeBottomNavigation({ onFabClick }) {
  const { copy } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSettingsClick = async () => {
    try {
      await NativeSettings.openSettings();
    } catch (error) {
      console.error('Failed to open native settings:', error);
      // Fallback to web settings page
      navigate('/settings');
    }
  };
  const iconSizePx = "22px";
  const navItems = [
    { to: "/goals", icon: <TbFocus2 />, label: copy.goals.headline },
    { to: "/calendar", icon: <TbCalendar />, label: copy.navigation.mobile.calendar },
    { to: "/vision-board", icon: <TbEye />, label: copy.navigation.mobile.board },
    { to: "/finance", icon: <TbPigMoney />, label: "Finance" },
    { to: "/wishlist", icon: <TbHeart />, label: copy.navigation.mobile.wishlist },
    { to: "/settings", icon: <TbSettings />, label: copy.navigation.mobile.settings },
  ];

  return (
    <nav className="fixed bottom-0 left-0 w-full bg-white shadow-lg flex justify-around items-center z-50 card-base-border-top px-2 py-4 pb-8">
      {/* Left side items (3) group */}
      <div className="flex flex-1 justify-around items-center !mr-6">
        {navItems.slice(0, 3).map((item) => (
          <button
            key={item.to}
            onClick={() => navigate(item.to)}
            className={`flex flex-col items-center ${location.pathname === item.to ? "text-primary" : "text-color"}`}
          >
            <div style={{ fontSize: iconSizePx }}>{item.icon}</div>
            <span className="text-xs !mt-2">{item.label}</span>
          </button>
        ))}
      </div>
      {/* Floating Action Button (FAB) */}
      <button
        className="absolute left-1/2 -translate-x-1/2 -top-4 bg-primary text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg border-2 border-white z-60"
        style={{ zIndex: 60 }}
        onClick={onFabClick}
        aria-label="Add"
      >
        <FaPlus size={18} />
      </button>
      {/* Right side items (3) group */}
      <div className="flex flex-1 justify-around items-center !ml-6">
        {navItems.slice(3).map((item) => (
          <button
            key={item.to}
            onClick={() => item.to === '/settings' ? handleSettingsClick() : navigate(item.to)}
            className={`flex flex-col items-center ${location.pathname === item.to ? "text-primary" : "text-color"}`}
          >
            <div style={{ fontSize: iconSizePx }}>{item.icon}</div>
            <span className="text-xs !mt-2">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}

NativeBottomNavigation.propTypes = {
  onFabClick: PropTypes.func.isRequired,
};
